import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;
const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });
const prefix = '/api/v1';

export const fetchPhonemes = (params = {}) => {
    return axios.get(`${prefix}/phonemes/`, { params });
};

export const searchPhonemes = (word, speaker, params = {}) => {
    return fetchPhonemes({
        search: word,
        speaker__slug: speaker,
        ...params
    });
};

export const savePhoneme = (data, params = {}) => {
    return axios.post(`${prefix}/phonemes/`, data, { params });
};

export const fetchSample = (id, speaker, params = {}) => {
    return axios.get(`${prefix}/phonemes/${id}/sample/`, {
        params: {
            speaker__slug: speaker,
            ...params
        }
    });
};

export const adminFetchPhonemes = (params = {}) => {
    return axios.get(`${prefix}/admin/speech_settings/phonemes/`, { params });
};

export const adminFetchSample = (id, params = {}) => {
    return axios.get(`${prefix}/admin/speech_settings/phonemes/${id}/sample/`, { params });
};

export const adminChangeActivity = (id, is_active, params = {}) => {
    return axios.patch(
        `${prefix}/admin/speech_settings/phonemes/${id}/`,
        {
            is_active
        },
        { params }
    );
};

export const adminDeletePhoneme = (id, params = {}) => {
    return axios.delete(`${prefix}/admin/speech_settings/phonemes/${id}/`, { params });
};
